module.exports = __webpack_public_path__ + "img/logo.59f633fa.svg";